
import { mdiVolumeHigh, mdiVolumeOff } from "@mdi/js"
import intersectionObserver from "@/mixins/intersectionObserver"
import themes from "@/mixins/themes"
import media from "@/mixins/media"

export default {
    name: "JobFloatingMediaV3",
    components: {
        ResponsiveVimeo: () =>
            import("@/components/base/video/ResponsiveVimeo"),
        OPicture: () => import("@/components/base/image/OPicture"),
        Button: () => import("@/components/base/Button"),
    },
    mixins: [themes, intersectionObserver, media],
    emits: ["show-more"],
    props: {
        /** Either video or image object */
        media: {
            type: Object,
            default: null,
        },
        /** Loads thumbnail eager */
        eager: {
            type: Boolean,
            default: false,
        },
        /** Mutes video, disables sound switch button and tooltip */
        muted: {
            type: Boolean,
            default: false,
        },
        /** If true, checks the downlink speed to determine, if video should be played.
         *  If false, always plays video */
        checkSpeed: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        videoMuted: true,
        enableSwitchSound: false,
        showTooltip: false,
    }),
    icons: {
        mdiVolumeHigh,
        mdiVolumeOff,
    },
    inject: {
        editorMode: {
            from: "editorMode",
            default: false,
        },
    },
    computed: {
        contentStyles() {
            if (this.alignment !== "center") return {}
            if (this.themeIsTextDark(this.theme.backgroundPrimary))
                return {
                    "box-shadow": "0 10px 20px 0 #00295e80 !important",
                }
            return {
                "box-shadow": "0 10px 20px 0 #ffffff40 !important",
            }
        },
    },
    methods: {
        onVideoReady({ hasAudio }) {
            this.observeIntersection(
                this.$refs["video-player"].$el,
                () => {
                    this.$refs["video-player"]?.playVideo()
                },
                () => {
                    this.$refs["video-player"]?.pauseVideo()
                },
                {
                    threshold: 0.4,
                }
            )
            this.enableSwitchSound = hasAudio
        },
        onSwitchSound() {
            if (this.enableSwitchSound) this.videoMuted = !this.videoMuted
            else {
                this.showTooltip = true
                setTimeout(() => (this.showTooltip = false), 3000)
            }
        },
    },
}
